import React from 'react';
import { Keypair } from '@solana/web3.js';
import * as bip39 from 'bip39';
import * as ed25519 from 'ed25519-hd-key';
import bs58 from 'bs58';

const DERIVATION_PATH = "m/44'/501'/0'/0'";

interface WalletGeneratorProps {
    setPrivateKey: (key: string) => void;
}

export default function WalletGenerator({ setPrivateKey }: WalletGeneratorProps) {
    const generateWallet = async () => {
        const mnemonic = bip39.generateMnemonic();
        const seed = await bip39.mnemonicToSeed(mnemonic);
        const derivedSeed = ed25519.derivePath(DERIVATION_PATH, seed.toString('hex')).key;
        const keypair = Keypair.fromSeed(derivedSeed);

        const pubkey = keypair.publicKey.toBase58();
        const privkey = bs58.encode(keypair.secretKey);

        setPrivateKey(privkey);

        const rows = ['Public Key,Private Key (base58),Seed Phrase', `${pubkey},${privkey},${mnemonic}`];
        const csvContent = rows.join('\n');
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${pubkey}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div>
            <button onClick={generateWallet}>Generate Wallet</button>
        </div>
    );
}
